import React, { Component } from 'react';
import cx from 'classnames';
import memoizeOne from 'memoize-one';

import getOrgAlias from '@shootsta/get-alias';
import { FormModal } from '../../../ui-kit';

import AnonymousUserForm from './AnonymousUserForm';
import VideoAnonymousUserForm from './VideoAnonymousUserForm';
import LoginForm from './LoginForm';
import { login, getFirstAndLastNameByName } from '../utils';

import '../styles/_welcome-guest.scss';




















export default class WelcomeGuestModal extends Component


{
  updateField = memoizeOne((field) => ({
    target: { value }
  }) => {
    if (field === 'name') {
      const { firstName, lastName } = getFirstAndLastNameByName(value);
      this.setState({ firstName, lastName });
    } else {
      this.setState({ [field]: value });
    }
  });

  updateLoginFormIsVisible = memoizeOne(({ visible }) => () => {
    this.setState({ loginFormIsVisible: visible, error: '' });
  });

  constructor(props) {
    super(props);

    this.state = {
      loginFormIsVisible: false,
      submitting: false
    };
  }

  loginAnonymousUser = () => {
    const { firstName, lastName } = this.state;
    const { loginAnonymousUserRequest } = this.props;

    return this.login(
      loginAnonymousUserRequest,
      { firstName, lastName },
      { dataKey: 'loginAnonymousUser' }
    );
  };

  loginExistingUser = () => {
    const { email, password } = this.state;
    const { loginRequest } = this.props;

    return this.login(loginRequest, { email, password, alias: getOrgAlias() });
  };

  login = async (loginRequest, payload, dataKey) => {
    this.setState({ error: '', submitting: true });

    const result = await login(loginRequest, payload, dataKey);

    this.setState(result);
  };

  handleClose = () => {
    this.setState({ isClosed: true });
  };

  render() {
    const { onClose, visible, isPublicVideo } = this.props;
    const { loginFormIsVisible, isClosed, submitting, error, firstName, lastName } = this.state;

    const publicLoginTitle = isPublicVideo ? 'Let people know who you are!' : 'Hey, Welcome to the HUB';
    const title = loginFormIsVisible ? 'Hey, Welcome Back' : publicLoginTitle;


    const publicLoginSubTitle = isPublicVideo ?
    `To start commenting on this video,\n
      please enter your name below or log in\n
      if you already have a Shootsta account.` :
    'Please enter your full name or if you have an account, log back into the HUB';
    const subTitle = loginFormIsVisible ?
    'Jump back into the HUB and start collaborating' :
    publicLoginSubTitle;

    const publicLoginForm = isPublicVideo ?

    <VideoAnonymousUserForm
      onClose={onClose}
      updateName={this.updateField('name')}
      displayLoginForm={this.updateLoginFormIsVisible({ visible: true })}
      handleAnonymousUser={this.loginAnonymousUser}
      busy={submitting}
      error={error}
      disabled={!firstName} /> :



    <AnonymousUserForm
      onClose={onClose}
      updateFirstName={this.updateField('firstName')}
      updateLastName={this.updateField('lastName')}
      displayLoginForm={this.updateLoginFormIsVisible({ visible: true })}
      handleAnonymousUser={this.loginAnonymousUser}
      busy={submitting}
      error={error}
      disabled={!firstName || !lastName} />;



    const loginForm = loginFormIsVisible ?

    <LoginForm
      onCancel={this.updateLoginFormIsVisible({ visible: false })}
      handleLogin={this.loginExistingUser}
      updateEmail={this.updateField('email')}
      updatePassword={this.updateField('password')}
      busy={submitting}
      error={error} /> :

    publicLoginForm;

    return (
      <div
        className={cx(
          'welcome-guest',
          { 'welcome-guest--login': loginFormIsVisible || isPublicVideo }
        )}>

        <FormModal
          visible={visible && !isClosed}
          title={title}
          hideFooter
          closeOnEsc={false}
          closeMaskOnClick={false}
          showHeaderCloseButton={false}
          subtitle={subTitle}
          onClose={this.handleClose}>

          {loginForm}
        </FormModal>
      </div>);

  }
}